import React, {Component} from 'react';
import {
    IconButton,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Icon,
    TablePagination, Grid
} from "@material-ui/core";
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import {endpoints, http} from '../../configs/http';
import {thousand} from "../../misc/helpers";
import moment from "moment";
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';

import { createMuiTheme } from '@material-ui/core'
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";

import { withStyles } from "@material-ui/core/styles";
import {ValidatorForm} from "react-material-ui-form-validator";
import download from 'downloadjs'
import {Loader} from "react-overlay-loader";
import {toast, ToastContainer} from "react-toastify";
const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2)
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500]
    }
});

const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="Close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2)
    }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(1)
    }
}))(MuiDialogActions);


export const customTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#229858',
            light:  '#229858',
            dark: '#229858',
        },
        secondary: {
            main: '#229858',
        },
    },
})


const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
}));

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = (event) => {
        onChangePage(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onChangePage(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onChangePage(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (

        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>

    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};
let today = new Date();
let pastYear = new Date('Apr 30, 1990');


class PaymentHistory extends Component {

    constructor() {
        super();
        this.state = {
            page : 0,
            histories : [

            ],
            rowsPerPage: 5,
            loading: false,
            status: "APPROVED,SUCCESS",
            totalPages: 0,
            open:false,
            totalElements:0,
            anchorEl:null,
            openmenu:false,
            currentMember: null,
            filterBy: "",
            params: "",
            selectedDate: new Date(),

            error: true,
            startDate: null,
            endDate: null,
            showFilter: false,
            currentHistory: null,
            loadingReceipt: false




        };
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }
    handleClose = () => {
        this.setState({ currentHistory: null,open: false });
    };

    fetchData(page, rowscount){
        // const {filterBy, params} = this.state;
        this.setState({
            loading:true
        });

        let url = endpoints.PAYMENT_DETAILS.replace(':page', page).replace(
            ':size',
            rowscount,
        );
        if (this.state.startDate && this.state.endDate) {
            url = endpoints.PAYMENT_DETAILS_WITH_DATES.replace(':page', page)
                .replace(':startDate',  moment(this.state.startDate).format("YYYY-MM-DD"))
                .replace(':endDate', moment(this.state.endDate).format("YYYY-MM-DD")).replace(
                    ':size',
                    rowscount,
                );
        }


        http.get(url

        )
            .then(response => {
                console.log(response.content);
                this.setState({
                    error: false,
                    loading:false,
                    histories: response.content,
                    totalPages: response.totalPages,
                    totalElements: response.totalElements
                });

            })
            .catch(error => {
                this.setState({
                    loading:false,
                    error: true
                });
                // let errorMessage =
                //     (typeof error === "string" && error) ||
                //     "An error occured, please try again in a moment.";
                //
                // const Toast = Swal.mixin({
                //     toast: true,
                //     position: "top-end",
                //     showConfirmButton: false,
                //     timer: 3000
                // });
                //
                // Toast.fire({
                //     icon: "error",
                //     title: errorMessage
                // });
            });
    }

    downloadReceipt = (id, month, year) => {
        this.handleClose()
        console.log("here")
        this.setState({
            loadingReceipt: true
        })
        http
            .get(endpoints.DOWNLOAD_RECEIPT.replace(":id", id),{
                responseType: 'blob',
            })
            .then(async (resp) => {

                    console.log(resp)
                var name =  month + ""+year+ "MKAN-RECEIPT.PDF"
                download(resp, name, "application/pdf")
                this.setState({
                    loadingReceipt: false,
                });

                console.log("yes hhh")
                toast.success("Receipt downloaded")
            })
            .catch((err) => {
                this.setState({
                    loadingReceipt: false,
                });
                let errorMessage =
                    (typeof err === 'string' && err) ||
                    'An error occured, please try again in a moment.';
                // alert(JSON.stringify(error));
                console.log(errorMessage);
                toast.error(errorMessage)

            });
    }
    componentDidMount() {
        const {page,rowsPerPage} = this.state;
        this.fetchData(page, rowsPerPage);
    }

    fetchPayment = () => {
        console.log('fetttc');
        this.setState({
            isFetching: true,
        });
        let url = endpoints.PAYMENT_DETAILS.replace(':page', 0).replace(
            ':size',
            20,
        );
        if (this.state.startDate && this.state.endDate) {
            url = endpoints.PAYMENT_DETAILS_WITH_DATES.replace(':page', 0)
                .replace(':startDate', this.state.startDate)
                .replace(':endDate', this.state.endDate).replace(
                    ':size',
                    20,
                );
        }

        http
            .get(url)
            .then(async (resp) => {


                this.setState({
                    isFetching: false,
                    showMessage: false,
                    transactions: resp.content,
                    last_page: resp.last,
                    page: this.state.page + 1,
                });

                console.log("yes hhh")
            })
            .catch((err) => {
                this.setState({
                    isFetching: false,
                    last_page: false,
                });
                let errorMessage =
                    (typeof err === 'string' && err) ||
                    'An error occured, please try again in a moment.';
                // alert(JSON.stringify(error));
                console.log(errorMessage);
                this.setState({
                    snacksMessage: errorMessage,
                    showMessage: true,
                    errorMessage: errorMessage,
                });
            });
    };
    handleChangePage = (event, newPage) => {
        this.setState({
            page: newPage
        });
        this.fetchData(newPage, this.state.rowsPerPage);
    };
    handleChangeRowsPerPage = event => {
        // setRowsPerPage(+event.target.value);
        this.setState({
            rowsPerPage:+event.target.value
        });

        this.fetchData(this.state.page, +event.target.value);
    };
    handleDateChangeStart = (date) => {
        const { endDate, rowsPerPage} = this.state
        this.setState({
            startDate : date
        }, ()=>{
            if (endDate){
                this.setState({
                    page : 0
                })
                this.fetchData(0, rowsPerPage);
            }
        })
    };

    handleDateChangeEnd = (date) => {
        const { startDate, rowsPerPage} = this.state
        this.setState({
            endDate : date
        }, ()=>{
            if (startDate){
                this.setState({
                    page : 0
                })
                this.fetchData(0, rowsPerPage);
            }
        })
    };

    render() {
        const {page, rowsPerPage, histories, totalPages,loading,currentMember,totalElements,  error, selectedDate, showFilter, startDate, endDate, currentHistory, loadingReceipt} = this.state;
        return (
            <MuiThemeProvider theme={customTheme}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Loader fullPage loading={loadingReceipt} />
              <div>
                <div className="page-content" style={{marginTop: 10}}>

                    <div className="d-flex justify-content-between align-items-center flex-wrap grid-margin">
                        <div>
                            <h4 className="mb-3 mb-md-0">Payment History</h4>
                        </div>
                        <div className="d-flex align-items-center flex-wrap text-nowrap">
                            {!showFilter
                            ?
                                <a href="#"
                                   onClick={()=> this.setState({
                                       showFilter: true
                                   })}
                                   className="btn btn-primary btn-icon-text mb-2 mb-md-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                         fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                         stroke-linejoin="round"
                                         className="feather feather-download-cloud btn-icon-prepend">
                                        <polyline points="8 17 12 21 16 17"></polyline>
                                        <line x1="12" y1="12" x2="12" y2="21"></line>
                                        <path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"></path>
                                    </svg>
                                    Filter
                                </a>
                                :
                                <Grid container spacing={3}>

                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <KeyboardDatePicker
                                            maxDate={
                                                endDate
                                                    ? new Date(
                                                    Date.parse(
                                                        moment(endDate).format('YYYY-MM-DDTHH:mm:ss.sssZ'),
                                                    ),
                                                    )
                                                    : today
                                            }

                                            margin="normal"
                                            id="date-picker-dialog"
                                            label="From"
                                            format="MM/dd/yyyy"
                                            value={startDate}


                                            onChange={this.handleDateChangeStart}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <KeyboardDatePicker
                                            style={{marginTop:15}}
                                            minDate={
                                                startDate
                                                    ? new Date(
                                                    Date.parse(
                                                        moment(startDate).format('YYYY-MM-DDTHH:mm:ss.sssZ'),
                                                    ),
                                                    )
                                                    : pastYear
                                            }
                                            margin="normal"
                                            id="date-picker-dialog"
                                            label="To"
                                            format="MM/dd/yyyy"
                                            value={endDate}
                                            onChange={this.handleDateChangeEnd}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                // <div>
                                //     <KeyboardDatePicker
                                //         maxDate={
                                //             endDate
                                //                 ? new Date(
                                //                 Date.parse(
                                //                     moment(endDate).format('YYYY-MM-DDTHH:mm:ss.sssZ'),
                                //                 ),
                                //                 )
                                //                 : today
                                //         }
                                //
                                //         margin="normal"
                                //         id="date-picker-dialog"
                                //         label="From"
                                //         format="MM/dd/yyyy"
                                //         value={startDate}
                                //
                                //
                                //         onChange={this.handleDateChangeStart}
                                //         KeyboardButtonProps={{
                                //             'aria-label': 'change date',
                                //         }}
                                //     />
                                //
                                //     <KeyboardDatePicker
                                //         style={{marginTop:15}}
                                //         minDate={
                                //             startDate
                                //                 ? new Date(
                                //                 Date.parse(
                                //                     moment(startDate).format('YYYY-MM-DDTHH:mm:ss.sssZ'),
                                //                 ),
                                //                 )
                                //                 : pastYear
                                //         }
                                //         margin="normal"
                                //         id="date-picker-dialog"
                                //         label="To"
                                //         format="MM/dd/yyyy"
                                //         value={endDate}
                                //         onChange={this.handleDateChangeEnd}
                                //         KeyboardButtonProps={{
                                //             'aria-label': 'change date',
                                //         }}
                                //     />
                                //     {/*<a href="#"*/}
                                //     {/*   onClick={()=> this.setState({*/}
                                //     {/*       showFilter: true*/}
                                //     {/*   })}*/}
                                //     {/*   className="btn btn-primary btn-icon-text mb-2 mb-md-0">*/}
                                //     {/*    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"*/}
                                //     {/*         fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"*/}
                                //     {/*         stroke-linejoin="round"*/}
                                //     {/*         className="feather feather-download-cloud btn-icon-prepend">*/}
                                //     {/*        <polyline points="8 17 12 21 16 17"></polyline>*/}
                                //     {/*        <line x1="12" y1="12" x2="12" y2="21"></line>*/}
                                //     {/*        <path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"></path>*/}
                                //     {/*    </svg>*/}
                                //     {/*    Apply*/}
                                //     {/*</a>*/}
                                // </div>

                            }


                        </div>
                    </div>

                        <div className="row">
                            <div className="col-md-12 grid-margin stretch-card">
                                <div className="card">
                                    <div className="card-body">
                                        <h6 className="card-title">Payment History</h6>

                                        <div className="table-responsive">
                                            {loading &&
                                            <div className="text-center">
                                                <span className='spinner-grow'></span>
                                            </div>
                                            }

                                            <div className="w-100 overflow-auto card mt-20" id="pdfdiv">
                                                <Table style={{whiteSpace: "pre", padding: 20}}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell className="px-5">Amount</TableCell>
                                                            <TableCell className="px-0">Description</TableCell>
                                                            <TableCell className="px-0">Date</TableCell>
                                                            <TableCell className="px-2">Action</TableCell>
                                                        </TableRow>
                                                    </TableHead>


                                                    {histories.length > 0 &&
                                                    <TableBody>
                                                        {histories
                                                            .map((history, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell className="px-5 capitalize" align="left">
                                                                        {`₦${thousand(
                                                                            parseInt(history.totalFee)
                                                                        )}`}

                                                                    </TableCell>
                                                                    <TableCell className="px-0 capitalize" align="left">
                                                                        Payment for {history.paymentMonth} {history.paymentYear}
                                                                    </TableCell>
                                                                    <TableCell className="px-0 capitalize" align="left">
                                                                        {moment(history.paymentDate).format("MMMM Do YYYY")}
                                                                    </TableCell>
                                                                    <TableCell className="px-2">
                                                                        <div>
                                                                            <a href="#"
                                                                               onClick={()=> this.setState({
                                                                                   currentHistory: history,
                                                                                   open: true
                                                                               })}
                                                                               className="btn btn-primary btn-icon-text mb-2 mb-md-0 ">

                                                                                View
                                                                            </a>

                                                                            {/*<IconButton*/}
                                                                            {/*    aria-label="More"*/}
                                                                            {/*    aria-owns={openmenu ? "long-menu" : undefined}*/}
                                                                            {/*    aria-haspopup="true"*/}
                                                                            {/*    onClick={(event)=>*/}
                                                                            {/*        // this.handleOpenMenu(event, member)*/}
                                                                            {/*    }*/}
                                                                            {/*>*/}
                                                                            {/*    <Icon>more_vert</Icon>*/}
                                                                            {/*</IconButton>*/}
                                                                            {/*<Menu*/}
                                                                            {/*    id="long-menu"*/}
                                                                            {/*    anchorEl={anchorEl}*/}
                                                                            {/*    open={openmenu}*/}
                                                                            {/*    onClose={this.handleCloseMenu}*/}
                                                                            {/*    PaperProps={{*/}
                                                                            {/*        style: {*/}

                                                                            {/*        }*/}
                                                                            {/*    }}*/}
                                                                            {/*>*/}
                                                                            {/*    <MenuItem*/}
                                                                            {/*        onClick={this.handleClickOpen}*/}
                                                                            {/*    >*/}
                                                                            {/*        View Details*/}
                                                                            {/*    </MenuItem>*/}

                                                                            {/*</Menu>*/}
                                                                        </div>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                    </TableBody>
                                                    }
                                                </Table>

                                                <TablePagination
                                                    className="px-16"
                                                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                                    component="div"
                                                    count={totalElements}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    // backIconButtonProps={{
                                                    //     "aria-label": "Previous Page"
                                                    // }}
                                                    //
                                                    // nextIconButtonProps={{
                                                    //     "aria-label": "Next Page"
                                                    // }}
                                                    onChangePage={this.handleChangePage}
                                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActions}
                                                />
                                            </div>

                                            {/*<table id="dataTableExample" className="table">*/}
                                            {/*    <thead>*/}
                                            {/*    <tr>*/}
                                            {/*        <th>ID</th>*/}
                                            {/*        <th>Sender ID</th>*/}
                                            {/*        <th>Purpose</th>*/}
                                            {/*        <th>Status</th>*/}
                                            {/*    </tr>*/}
                                            {/*    </thead>*/}
                                            {/*    <tbody>*/}
                                            {/*    <tr>*/}
                                            {/*        <td>1</td>*/}
                                            {/*        <td>Sedncash</td>*/}
                                            {/*        <td>Transaction</td>*/}
                                            {/*        <td>Activated</td>*/}
                                            {/*    </tr>*/}
                                            {/*    </tbody>*/}
                                            {/*</table>*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    {currentHistory &&
                    <Dialog
                        onClose={this.handleClose}
                        aria-labelledby="customized-dialog-title"
                        open={this.state.open}
                    >
                        <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
                            PAYMENT DETAILS FOR {moment(currentHistory.paymentDate).format("MMMM YYYY")}
                        </DialogTitle>
                        <DialogContent dividers>
                            <Typography gutterBottom>
                                <Table style={{whiteSpace: "pre"}}>
                                    <TableHead>
                                        {/*<TableRow>*/}
                                        {/*    <TableCell className="px-0">Payment Type</TableCell>*/}
                                        {/*    <TableCell className="px-0">Online Payment</TableCell>*/}
                                        {/*</TableRow>*/}
                                        <TableRow>
                                            <TableCell className="px-0">Month</TableCell>
                                            <TableCell className="px-0">{currentHistory.paymentMonth}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className="px-0">Year</TableCell>
                                            <TableCell className="px-0">{currentHistory.paymentYear}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className="px-0">Date Paid</TableCell>
                                            <TableCell className="px-0">{moment(currentHistory.paymentDate).format("MMMM Do YYYY")}</TableCell>
                                        </TableRow>
                                    </TableHead>


                                </Table>
                            </Typography>
                            <Typography gutterBottom>
                                <Table style={{whiteSpace: "pre", marginTop: '20'}}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className="px-0" style={{color:'green'}}>FEE</TableCell>
                                            <TableCell className="px-0" style={{color:'green'}}>AMOUNT</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell className="px-0">Chanda</TableCell>
                                            <TableCell className="px-0">{currentHistory.chandaFee}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className="px-0">Welfare</TableCell>
                                            <TableCell className="px-0">{currentHistory.welfareFee}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className="px-0">Sport</TableCell>
                                            <TableCell className="px-0">{currentHistory.sportFee}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className="px-0">Ta'leem Tarbiyya</TableCell>
                                            <TableCell className="px-0">{currentHistory.taleemFee}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className="px-0">Scholarship Fee</TableCell>
                                            <TableCell className="px-0">{currentHistory.scholarshipFee}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className="px-0">Vehicle Fee</TableCell>
                                            <TableCell className="px-0">{currentHistory.vehicleFee}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className="px-0">Tabligh Fee</TableCell>
                                            <TableCell className="px-0">{currentHistory.tablighFee}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className="px-0">Ijtema Fee</TableCell>
                                            <TableCell className="px-0">{currentHistory.ijtemaFee}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className="px-0">Land and building Fee</TableCell>
                                            <TableCell className="px-0">{currentHistory.landAndBuildingFee}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className="px-0">Atfal Subsidy Fee</TableCell>
                                            <TableCell className="px-0">{currentHistory.atfalSubsidyFee}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className="px-0">MGQS Fee</TableCell>
                                            <TableCell className="px-0">{currentHistory.mgqsFee}</TableCell>
                                        </TableRow>

                                    </TableBody>
                                </Table>
                            </Typography>

                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.downloadReceipt(currentHistory.id, currentHistory.paymentMonth, currentHistory.paymentYear)}>Download Receipt</Button>
                            <Button onClick={this.handleClose} color="primary">
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                    }


                </div>
            </div>

            </MuiPickersUtilsProvider>
                <ToastContainer />
            </MuiThemeProvider>
        );
    }
}

export default PaymentHistory;
